import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Button, Card, DatePicker, Form, Input, Row, Col, message, Modal } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Select } from "antd";
// src/api/index.ts
import { applyleave, getprofile } from "../../utils/API";
import { AuthContext } from "../../Auth/AuthContext";

const { Option } = Select; // Fix for Option
const { TextArea } = Input;
interface ApplyleaveFormModalProps {
  visible: boolean;
  onClose: () => void;
  onTaskCreated: () => void;
  refreshLeaves: () => void; // Optional prop for refreshing leaves

}
const ApplyLeave: React.FC<ApplyleaveFormModalProps> = ({ visible, onClose, onTaskCreated, refreshLeaves }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = React.useState(false);
  const { authData } = useContext(AuthContext);
  const [leaveType, setLeaveType] = React.useState<string | null>(null);
  const userId = authData?.user?._id;
  const [leaveBalance, setLeaveBalance] = React.useState<number | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const profileResponse = await getprofile({});
        // console.log(profileResponse.leaveBalance);
        setLeaveBalance(profileResponse.leaveBalance);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      if (!userId) {
        message.error("User ID not found. Please log in again.");
        return;
      }

      const payload = {
        userId,
        startDate: values.startDate.format("DD-MM-YYYY"),
        endDate: values.endDate.format("DD-MM-YYYY"),
        reason: values.reason,
        leaveType: values.leaveType === "half" ? "Half Leave" : "Full Leave",
        leaveReason: values.leaveReason === "sick"
          ? "Sick"
          : values.leaveReason === "vacation"
            ? "Casual"
            : "Emergency",
      };

      const response = await applyleave(payload);

      // console.log("API Response:", payload); // ✅ Log API response

      message.success("Leave apply successfully!");
      form.resetFields();
      navigate("/leave"); // Redirect after success
    } catch (error) {
      // console.error("API Error:", error); // ✅ Log error details
      message.error("Failed to apply leave");
    } finally {
      setIsLoading(false);
      refreshLeaves();
      onClose();
    }
  };



  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered={false}// Disable centered to use top positioning
      destroyOnClose
      className="custom-modal"
      style={{
        bottom: 20,
        top: 20,
        // maxHeight: 'calc(100vh - 30px)',
        margin: '0 auto',
        position: 'relative',
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Create New Leave
        </div>
      }
      bodyStyle={{
        // maxHeight: 'calc(90vh - 55px)',
        overflowY: 'auto',
        // padding: '20px',
        fontFamily: "inter, sans-serif",
      }}

    >
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="horizontal"
        // labelCol={{ span: 5 }}
        // wrapperCol={{ span: 18 }}
        // colon={false}
        style={{ margin: 0 }}
      >
        <div className="elements">
          {/* Leave Balance Right */}

          {leaveBalance !== null && (
            <Card
              bordered={false}
              className="bg-blue-50 border border-blue-300 text-blue-700 font-semibold rounded-xl w-full"
            >
              <div style={{ fontSize: "20px", fontWeight: 600, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Total Leave Balance:</span>
                <span style={{ fontSize: "28px", fontWeight: "bold" }}>{leaveBalance}</span>
              </div>
            </Card>
          )}

          {/* Form Left */}

          <Form form={form} layout="horizontal"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 20 }}
            colon={false} onFinish={handleSubmit}
          >
            <div className="py-2">
              {/* Leave Duration */}
              <Form.Item
                label={
                  <span style={{
                    color: '#4b5563', // Medium gray color similar to the image
                    fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                    fontSize: '14px', // Approximate font size based on the image
                    fontWeight: 500, // Medium weight to match "font-medium"
                    paddingLeft: "15px",
                  }}>
                    Leave Duration <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="leaveType"
                required={false}
                rules={[{ required: true, message: "Please Select Duration" }]}
                style={{ marginBottom: "16px" }}
              >
                <Select
                  placeholder="Select Leave Duration"
                  className="CustomSelect"
                  onChange={(value) => {
                    setLeaveType(value);
                    const startDate = form.getFieldValue("startDate");
                    if (value === "half" && startDate) {
                      form.setFieldsValue({ endDate: startDate });
                    }
                  }}
                >
                  <Option value="half">Half Day</Option>
                  <Option value="full">Full Day</Option>
                </Select>
              </Form.Item>


              {/* Start Date */}
              <Form.Item
                label={
                  <span style={{
                    color: '#4b5563', // Medium gray color similar to the image
                    fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                    fontSize: '14px', // Approximate font size based on the image
                    fontWeight: 500, // Medium weight to match "font-medium"
                    paddingLeft: "15px",
                  }}>
                    Start Date <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="startDate"
                required={false}
                rules={[{ required: true, message: "Please Select Start Date" }]}
                style={{ marginBottom: "16px" }}
              >
                <DatePicker
                  placeholder="Select Start Date"
                  className="Allinput"
                  format="DD-MM-YYYY"
                  onChange={(date) => {
                    if (leaveType === "half") {
                      form.setFieldsValue({ endDate: date });
                    } else {
                      const currentToDate = form.getFieldValue("endDate");
                      if (date && (!currentToDate || !currentToDate.isAfter(date))) {
                        form.setFieldsValue({ endDate: date.add(1, "day") });
                      }
                    }
                  }}
                />

              </Form.Item>

              {/* End Date */}
              <Form.Item
                label={
                  <span style={{
                    color: '#4b5563', // Medium gray color similar to the image
                    fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                    fontSize: '14px', // Approximate font size based on the image
                    fontWeight: 500, // Medium weight to match "font-medium"
                    paddingLeft: "15px",
                  }}>
                    End Date <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="endDate"
                required={false}
                dependencies={["startDate"]}
                rules={[
                  { required: true, message: "Please Select End Date" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const startDate = getFieldValue("startDate");
                      if (!startDate || !value) return Promise.resolve();

                      if (value.isSame(startDate, "day") || value.isAfter(startDate, "day")) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("End Date must be same or after Start Date"));
                    },
                  }),
                ]}
                style={{ marginBottom: "16px" }}
              >
                <DatePicker
                  placeholder="Select End Date"
                  className="Allinput"
                  format="DD-MM-YYYY"
                  disabled={leaveType === "half"} // 👈 disable for half day
                  disabledDate={(current) => {
                    const startDate = form.getFieldValue("startDate");
                    return startDate && current.isBefore(startDate, "day");
                  }}
                />

              </Form.Item>

              {/* Leave Type */}
              <Form.Item
                label={
                  <span style={{
                    color: '#4b5563', // Medium gray color similar to the image
                    fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                    fontSize: '14px', // Approximate font size based on the image
                    fontWeight: 500, // Medium weight to match "font-medium"
                    paddingLeft: "15px",
                  }}>
                    Leave Type <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="leaveReason"
                required={false}
                rules={[{ required: true, message: "Please Select Type" }]}
                style={{ marginBottom: "16px" }}
              >
                <Select placeholder="Select Leave Type" className="CustomSelect">
                  <Option value="sick">Sick</Option>
                  <Option value="vacation">Casual</Option>
                  <Option value="personal">Emergency</Option>
                </Select>
              </Form.Item>

              {/* Reason */}
              <Form.Item
                label={
                  <span style={{
                    color: '#4b5563', // Medium gray color similar to the image
                    fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                    fontSize: '14px', // Approximate font size based on the image
                    fontWeight: 500, // Medium weight to match "font-medium"
                    paddingLeft: "15px",
                  }}>
                    Reason <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="reason"
                required={false}
                rules={[{ required: true, message: "Please Enter Reason" }]}
                style={{ marginBottom: "16px" }}
              >
                <TextArea placeholder="Enter reason" rows={3} className="Allinputtextarea" />
              </Form.Item>
            </div>
          </Form>


        </div>


        {/* Submit Button */}
        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3 "
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>

              <button className="allsubmitebutton" disabled={isLoading}>
                {isLoading ? "Applying Leave..." : "Apply Leave"}
              </button>
            </div>
          </Col>
        </Row>

      </Form>
    </Modal>
  );
};

export default ApplyLeave;
